module.exports = __webpack_public_path__ + "static/media/AI_18.49596b2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_18.png
// module id = 133
// module chunks = 0